import DownloadPdfButton from '../../../components/common/pdf/DownloadPdfButton';
import { chartReportConfigs } from '../../../utils/config/chartReportConfig';
import WidgetType from '../../../components/dynamicRenderer/WidgetRenderer';
import { useWidgetInfo } from "../../../hooks/widget/useWidgetInfo";
import { useReportData } from '../../../hooks/data/useReportData';
import { useChart } from '../../../hooks/reports/useReportChart';
import CircularProgress from "@mui/material/CircularProgress";
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import { useLocation } from "react-router-dom";
import './dualreport.css';

const dualReportConfigs = {
  "Cost Analysis": [ 
    { name: 'cost analysis weekly', limit: 100 }, { name: 'cost analysis carrier', limit: 10 },
  ],
  "UPS RFP": [
    { name: 'UPS RFP', limit: 100 }, { name: 'RFP AREA CHART', limit: 100, params: { carrier: 'UPS' }}
  ],
  "FedEx RFP": [
    { name: 'FedEx RFP', limit: 100 }, { name: 'RFP AREA CHART', limit: 100, params: { carrier: 'FedEx' }}
  ],
  "DHL RFP": [
    { name: 'DHL RFP', limit: 100 }, { name: 'RFP AREA CHART', limit: 100, params: { carrier: 'DHL' }}
  ],
  "MicroDental Lab RFP":[
    { name: 'MICRODENTAL RFP', limit: 100, params: { carrier: 'UPS'  }}, { name: 'RFP AREA CHART', limit: 300, params: { carrier: 'UPS' } }
  ],
};

const DualReport = () => {
  const location = useLocation();
  const { reportName, reportId } = location.state || {};
  const reports = dualReportConfigs[reportName] || []; // For Report, get name to pass in chartReportConfigs
  const [reportOne, reportTwo] = reports;

  // GET: Report Data needed for report
  const { data: reportOneData } = useReportData(reportOne.name, reportOne.limit, reportOne.params);
  const { data: reportTwoData } = useReportData(reportTwo.name, reportTwo.limit, reportTwo.params);

  const reportOneConfig = chartReportConfigs[reportOne.name]; // Obtain Chart Config Infor
  const reportTwoConfig = chartReportConfigs[reportTwo.name];

  const chartOne = useChart(reportOneConfig, reportOneData); // Obtain Chart Information for report
  const chartTwo = useChart(reportTwoConfig, reportTwoData); 

  const widgetInfo = useWidgetInfo(reportId, reportName); // GET: Widget Data for report

  return (
    <div className='dualReportPage'>
      <div className="LandingContainer">
        <NavBar />
        <Sidebar />
        <div className="PageContent">
          <div className="reportTitle">
            <h1>{reportName}</h1>
          </div>
          <div className="dualReportWidgetSection">
            {widgetInfo.map(info => ( <WidgetType widgetInfo={info} /> ))}
          </div>
          <div className="dualReportsSpace">
            <div className="dualReportOne">
              <div className="reportTitle1">
                <h3>{reportOneConfig.chartSource}</h3>
              </div>
              <div className="chartContainer">
                {!reportOneData ? ( <CircularProgress size={30} /> ) : ( chartOne )}
              </div>
              {reportOneConfig?.pdf && reportOneData && (
                <div className="dualReportPdfDownload">
                  <DownloadPdfButton
                    data={reportOneData.data}
                    title={reportOneConfig.pdf.title || reportName}
                    highlightColumns={reportOneConfig.pdf.highlightColumns || []}
                  />
                </div>
              )}
            </div>
            <div className="dualReportTwo">
              <div className="reportTitle2">
                <h3>{reportTwoConfig.chartSource}</h3>
              </div>
              <div className="chartContainer"> 
                {!reportTwoData ? ( <CircularProgress size={30} />) : ( chartTwo )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DualReport